import { Caption, FormControl, Input } from '@farol-ds/react'
import { useMemo } from 'react'

import { calculatePasswordStrength } from '../../utils/passwordStrength'
import { PasswordStrengthIndicator } from '../password-strength-indicator/password-strength-indicator'
import styles from './password-field.module.scss'

interface PasswordFieldProps {
  value: string
  onChange: (value: string) => void
  onBlur?: () => void
  disabled?: boolean
  fullName?: string
  email?: string
  error?: string
  hideRequirements?: boolean
  label?: string
  hideStrengthIndicator?: boolean
}

export function PasswordField({
  value,
  onChange,
  onBlur,
  disabled,
  fullName,
  email,
  error,
  hideRequirements = false,
  label = 'Senha',
  hideStrengthIndicator = false,
}: PasswordFieldProps) {
  const strength = useMemo(
    () => calculatePasswordStrength(value, fullName, email),
    [value, fullName, email]
  )

  return (
    <FormControl error={!!error}>
      <FormControl.Label>{label}</FormControl.Label>
      <Input
        type="password"
        name="password"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        autoComplete="new-password"
        disabled={disabled}
      />
      {error && (
        <div className={styles.errorMessage}>
          <FormControl.ErrorMessage>{error}</FormControl.ErrorMessage>
        </div>
      )}
      {!hideStrengthIndicator && <PasswordStrengthIndicator strength={strength} />}
      {!hideRequirements && (
        <Caption asChild>
          <div className={styles.requirements}>
            <ul>
              <li>Deve ter no mínimo 8 caracteres</li>
              <li>
                Para mais segurança, evite usar seu nome, e-mail, caracteres idênticos ou
                sequenciais (Ex: aaa, 123)
              </li>
            </ul>
          </div>
        </Caption>
      )}
    </FormControl>
  )
}
